import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { TableCell, TableRow, Typography } from '@mui/material';
import TopCustomersHead from './Heads/TopCustomersHead';
import TopCustomersItem from './Items/TopCustomerItem';

export default function GeneralTable({ data, setData, section }) {

    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                <TableContainer>
                    <Table sx={{ minWidth: "auto", background: "white" }}>
                            {
                                section == "topCustomer" && <TopCustomersHead />
                            }
                        <TableBody>
                            {
                                data.length != 0 ?
                                (
                                    data.map((val, i) => {
                                        return (
                                            section == "topCustomer" && <TopCustomersItem data={val} rate={i + 1} key={i} />
                                        )
                                    })
                                ) : null
                            }
                            {
                                data.length == 0 && 
                                    <TableRow>
                                        <TableCell colSpan="6"><Typography sx={{width: "100%", textAlign: "center", p: 1}} variant='h5' color="#B2B2B2">موردی وجود ندارد.</Typography></TableCell>
                                    </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    )
}